import { render, staticRenderFns } from "./cuponesNoDisponibles.vue?vue&type=template&id=ebcdaac6&scoped=true"
import script from "./cuponesNoDisponibles.vue?vue&type=script&lang=js"
export * from "./cuponesNoDisponibles.vue?vue&type=script&lang=js"
import style0 from "./cuponesNoDisponibles.vue?vue&type=style&index=0&id=ebcdaac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcdaac6",
  null
  
)

export default component.exports